import { getAppEnvConfig } from "./env"

export const useGlobSetting = (): Readonly<any> => {
  const setting = getAppEnvConfig()
  return setting
}
